<template>
    <!--begin::Logo-->
    <Link :href="route('app.home')">
      <span>{{$page.props.globalVar.nomeMostra}}</span>
    </Link>
    <!--end::Logo-->
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
export default {
    components: {
        Link
    }
}
</script>
